import React, { useEffect } from 'react'
import Helmet from 'react-helmet'
import { Link, withRouter } from 'react-router-dom'
import './Error.scss'

const ERRORS = {
  401: {
    code: '401',
    message: 'You must be logged in to view this page.',
    secondaryMessage: 'Go to login page?',
    btnTitle: 'Login',
    path: '/login',
  },
  403: {
    code: '403',
    message: 'You do not have permissions to view this page.',
    secondaryMessage: 'Would you like to go home?',
    btnTitle: "Let's go home",
    path: '/',
  },
  404: {
    code: '404',
    message: 'The page you are looking for does not exist',
    secondaryMessage: 'Would you like to go home?',
    btnTitle: "Let's go home",
    path: '/',
  },
  500: {
    code: '500',
    message: 'There has been an internal server error.',
    btnTitle: 'Shop Now',
    path: '/',
  },
  Oops: {
    code: 'Oops',
    message: 'Something has gone terribly wrong.',
    btnTitle: 'Shop Now',
    path: '/',
  },
  trackingUnavailable: {
    code: 'Updates coming',
    message: 'Tracking is not currently available for this fulfillment',
    btnTitle: 'Back To My Account',
    path: '/myaccount',
  },
}
const DEFAULT_ERROR = 404

const ErrorComponent = props => {
  useEffect(() => {
    const queryObj = props.location
    try {
      const path = queryObj.pathname.split('/')[1]
    } catch (e) {}
  }, [])

  const { statusCode } = props.match.params
  const e = ERRORS[statusCode] ? ERRORS[statusCode] : ERRORS[DEFAULT_ERROR]

  return (
    <>
      <Helmet>
        <meta name="prerender-status-code" content={e.code} />
      </Helmet>
      <div className="error-wrapper error error-404">
        <div className="error-container">
          <div className="error-number">{e.code}</div>
          <div className="error-description">{e.message}</div>
          <div className="error-goback-text">{e.secondaryMessage}</div>
          <div className="error-goback-button">
            <Link to={e.path} className="btn btn-lg btn-primary">
              {e.btnTitle}
            </Link>
          </div>
          <div className="footer">&copy; 2023 Dealmed Tech</div>
        </div>
      </div>
    </>
  )
}

export default withRouter(ErrorComponent)
